export default ['log', 'info', 'warn', 'error', 'debug'];